// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"jP","navPanel":"jP","nav-panel-bg":"jQ","navPanelBg":"jQ","nav-panel-content":"jR","navPanelContent":"jR","none":"jS","block":"jT"};